/* eslint-disable */

import notifyMe from './notifyMe';

export default async function checkProductAvailability() {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const productHandle = productInfo.getAttribute('data-product-handle');
  if (!productHandle) return;

  // Extract store hash from Shopify.shop (e.g., "citta-sandbox.myshopify.com" -> "citta-sandbox")
  let storeHash = '';
  if (window.Shopify && Shopify.shop) {
    storeHash = Shopify.shop.replace(/\.myshopify\.com$/, '');
  }
  if (storeHash === 'citta-dev') {
    storeHash = 'citta-nz-b2c';
  }

  if (!storeHash) return;

  // Get current selected variant ID from product form
  const form = productInfo.querySelector('form.main-product-form');
  if (!form) return;
  
  const variantIdInput = form.querySelector('.product-variant-id');
  const currentVariantId = variantIdInput ? variantIdInput.value : null;
  
  // Get data attributes from the span element
  const dataSpan = form.querySelector('span[data-is-purchase-order]');
  const isPurchaseOrder = dataSpan ? dataSpan.getAttribute('data-is-purchase-order') === 'true' : false;
  
  // Get submit button reference for disabling/enabling
  let submitButton = null;
  // if (isPurchaseOrder) {
    const sectionId = productInfo.getAttribute('data-section');
    submitButton = sectionId 
      ? form.querySelector(`#ProductSubmitButton-${sectionId}`)
      : form.querySelector('[id^="ProductSubmitButton-"]');
    
    // Disable button while fetching quantity data
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.style.pointerEvents = 'none';
      submitButton.style.cursor = 'not-allowed';
    }
  // }

  // Build the API URL
  const endpoint = `${apiURL}/api/${storeHash}/products/${productHandle}/quantities`;

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if(data.data?.productByHandle) {
      const variants = data.data?.productByHandle?.variants?.edges;
      
      if (currentVariantId && variants) {
        // Find the current variant in the API response
        const currentVariant = variants.find(edge => {
          const variantGid = edge.node?.id || edge.id;
          // Extract numeric ID from GID format (e.g., "gid://shopify/ProductVariant/46379842273429" -> "46379842273429")
          const variantId = typeof variantGid === 'string' && variantGid.includes('/') 
            ? variantGid.split('/').pop() 
            : variantGid;

          return String(variantId) === String(currentVariantId);
        });
        
        if (currentVariant) {
          console.log('Current variant availability:', currentVariant);

          const inventoryItem = currentVariant.node?.inventoryItem;
          // If inventory item is missing (e.g. gift cards) or explicitly not tracked, skip availability logic
          if (!inventoryItem || inventoryItem.tracked === false) return;

          const inventoryLevels = inventoryItem?.inventoryLevels?.edges;

          if (inventoryLevels) {
            // Find "AAP Warehouse" location
            const aapWarehouse = inventoryLevels.find(edge => {
              return edge.node?.location?.name?.toLowerCase() === 'aap warehouse';
            });

            if (aapWarehouse) {
              // Get available quantity
              const availableQuantity = aapWarehouse.node?.quantities?.find(
                qty => qty.name === 'available'
              );
              
              if (availableQuantity) {
                console.log('AAP Warehouse available quantity:', availableQuantity.quantity);
                
                // If purchase order is true and quantity < 1, enable is_notify_me functionality
                if (isPurchaseOrder && availableQuantity.quantity < 1) {
                  // Remove hidden class from stock date element if it exists and has estimated stock date
                  const estimatedStockDate = dataSpan ? dataSpan.getAttribute('data-estimated-stock-date') : null;
                  if (estimatedStockDate) {
                    const stockDateElement = productInfo.querySelector('.product__inventory--stock-date');
                    if (stockDateElement && stockDateElement.classList.contains('hidden')) {
                      stockDateElement.classList.remove('hidden');
                    }
                  }
                  
                  if (submitButton) {
                    // Add btn--notify-me class
                    submitButton.classList.add('btn--notify-me');
                    
                    // Remove disabled attribute
                    submitButton.removeAttribute('disabled');
                    
                    // Change button text to "Notify Me When Back In Stock"
                    const buttonTextSpan = submitButton.querySelector('span');
                    if (buttonTextSpan) {
                      buttonTextSpan.textContent = 'Notify Me When Back In Stock';
                    }
                    
                    // Reinitialize notifyMe to attach the click handler
                    // Clone and replace button to avoid duplicate listeners (same approach as notifyMe.js)
                    const newButton = submitButton.cloneNode(true);
                    submitButton.parentNode.replaceChild(newButton, submitButton);
                    
                    // Update submitButton reference to the new button
                    submitButton = newButton;
                    
                    // Attach click handler to open modal
                    const notifyMeModal = document.querySelector('.notify-me-modal');
                    if (notifyMeModal) {
                      newButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        notifyMeModal.style.display = 'flex';
                      });
                    }
                    
                    // Reinitialize notifyMe to ensure all functionality is set up
                    notifyMe();
                  }
                } else if (!isPurchaseOrder && availableQuantity.quantity === 0) {
                  // Check if estimated stock date is empty
                  const estimatedStockDate = dataSpan ? dataSpan.getAttribute('data-estimated-stock-date') : null;
                  
                  // If no estimated stock date, set button to sold out
                  if (!estimatedStockDate) {
                    // Get submit button if not already available
                    let currentSubmitButton = submitButton;
                    if (!currentSubmitButton) {
                      const sectionId = productInfo.getAttribute('data-section');
                      currentSubmitButton = sectionId 
                        ? form.querySelector(`#ProductSubmitButton-${sectionId}`)
                        : form.querySelector('[id^="ProductSubmitButton-"]');
                    }
                    
                    if (currentSubmitButton) {
                      // Mark button as sold out with data attribute for finally block
                      currentSubmitButton.setAttribute('data-sold-out', 'true');
                      
                      // Set button to disabled (sold out state)
                      currentSubmitButton.disabled = true;
                      
                      // Change button text to "Sold Out"
                      const buttonTextSpan = currentSubmitButton.querySelector('span');
                      if (buttonTextSpan) {
                        buttonTextSpan.textContent = 'Sold Out';
                      }
                      
                      // Remove any notify-me classes if present
                      currentSubmitButton.classList.remove('btn--notify-me');
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  } catch (error) {
    console.error('Error checking product availability:', error);
  } finally {
    // Always remove the disabled state and pointer-events styles that we added
    // Get the current button (might have been cloned)
    const sectionId = productInfo.getAttribute('data-section');
    const currentButton = sectionId 
      ? form.querySelector(`#ProductSubmitButton-${sectionId}`)
      : form.querySelector('[id^="ProductSubmitButton-"]');
    
    if (currentButton) {
      // Always remove the pointer-events and cursor styles we added
      currentButton.style.pointerEvents = '';
      currentButton.style.cursor = '';
      
      // Remove disabled attribute unless we intentionally set it to sold out
      if (currentButton.getAttribute('data-sold-out') !== 'true') {
        currentButton.removeAttribute('disabled');
      }
    }
  }
}